import type { ColDef, GetRowIdParams, GridOptions, ValueFormatterParams } from 'ag-grid-community';

import { formatTel } from '~/utils/common';

import type { TypeStockReleaseCenter } from '~/types/stock.types';

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 상세 > 반출 출발지 센터 정보 테이블
 */
const getStockReleaseDetailCentersColumnDefs = () => {
  const gridOptions: GridOptions = {
    getRowId: (params: GetRowIdParams<TypeStockReleaseCenter>) => String(params.data.vendorReleaseCenterId),
    domLayout: 'autoHeight',
  };

  const columnDefs: ColDef<TypeStockReleaseCenter>[] = [
    {
      field: 'temperatureCodeObject.name',
      headerName: '보관 유형',
      width: 80,
    },
    {
      field: 'phoneNumber',
      headerName: '반출 출발지 번호',
      width: 130,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseCenter, TypeStockReleaseCenter['phoneNumber']>) =>
        value ? formatTel(value) : '-',
    },
    {
      headerName: '반출 출발지 주소',
      width: 200,
      flex: 1,
      valueGetter: ({ data }) => {
        const fullAddress = [data?.address, data?.detailAddress].filter(Boolean).join(' ');
        return fullAddress ? fullAddress : '-';
      },
    },
  ];

  return { gridOptions, columnDefs };
};

export default getStockReleaseDetailCentersColumnDefs;
